/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    postsCount:   8,
    postsStart:   1,
    postsType:    'post',
    postsNotIn:   [],
    consultantName:     '',
    consultantPosition: '',
    consultantWorkarea: '',
    consultantRegion:   '',
    consultantNotIn:    [],
    isLoading:          false,
    emptyResults:       false,
    is_iOS: function() {
      var iDevices = [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ];
      while (iDevices.length) {
        if (navigator.platform === iDevices.pop()){ return true; }
      }
      return false;
    },
    // All pages
    'common': {
      init: function() {
        var header = $("header.banner");
        var headerCont = $("header.banner > .container");
        var navbarHeight = header.outerHeight();
        var lastScrollTop = 0;
        var delta = 5;
        var didScroll;
        var win = $(window);

        $(window).scroll(function(event){
          didScroll = true;
        });

        if($('#loadMoreConsultants').length) {
          $(window).scroll(function(event){
            if(!Sage.emptyResults) {
              var winScrollTop = win.scrollTop();
              var scrolled = $(document).height() - win.height() - 300;
              if (winScrollTop > scrolled) {
                setTimeout(function(e) {
                  if(!Sage.isLoading) {
                    Sage.isLoading = true;
                    $('#loadMoreConsultants').click();
                  }
                }, 250);
              }
            }
          });
        }

        function hasScrolled() {
          var st = $(this).scrollTop();
          // Make sure they scroll more than delta
          if (Math.abs(lastScrollTop - st) <= delta) {
            return;
          }
          // If they scrolled down and are past the navbar, add class .nav-up.
          // This is necessary so you never see what is "behind" the navbar.
          if (st > lastScrollTop && st > navbarHeight) {
            // Scroll Down
            header.addClass('banner--scrolled');
            headerCont.fadeOut(400);
          } else {
            // Scroll Up
            if (st + $(window).height() < $(document).height()) {
              header.removeClass('banner--scrolled');
              headerCont.fadeIn(400);
            }
          }
          lastScrollTop = st;
        }

        setInterval(function() {
          if (didScroll) {
            hasScrolled();
            didScroll = false;
          }
        }, 250);


        $('.sticky-scroll').stick_in_parent({
          offset_top: header.outerHeight()
        });

        $('[data-action]').on('click', function(event) {
          event.preventDefault();

          var prefix = 'actions';
          var action = $(this).data('action');
          var namespace = Sage;


          if (namespace[prefix] && typeof namespace[prefix][action] === 'function') {
            namespace[prefix][action](event,$(this));
          }
        });

        if($('.process__list').length > 0) {
          var controller = new ScrollMagic.Controller();
          var tween = TweenMax.staggerFromTo(".process__circle__bg", 3, {opacity: 0.4}, {opacity: 1, ease: Back.easeOut}, 0.4);
          var scene = new ScrollMagic.Scene({triggerElement: ".process__list", duration: 600}).setTween(tween).addTo(controller);
        }

        $('#share').jsSocials({
          shares: [{
            share: 'linkedin',
            label: 'Dela',
          }, {
            share: 'facebook',
            label: 'Gilla',
          }]
        });

        function dotdotdotCallback(isTruncated, originalContent) {
          if (!isTruncated) {
            $("a.readmore", this).remove();
          }
        }
        $(".ellipsis").dotdotdot({
          after: "a.readmore",
          height: parseInt( $('.ellipsis').css('line-height'), 10) * 3,
          callback: dotdotdotCallback
        });
        $('.ellipsis a.readmore').on( 'click', function(event) {
          event.preventDefault();

          var container = $(this).parent().parent();
          container.trigger("destroy");
        });

        if($('#consultantsSearch').length > 0) {
          $('#consultantsSearch').submit(function(e){
            e.preventDefault();
            var formElements = $('#consultantsSearch input, #consultantsSearch select, #consultantsSearch button');
            var ajaxElements = $('.ajax-load__link');
            var security = $('#consultantsSearch').attr('data-security');

            Sage.consultantName     = $('#consultantsSearch input[name=name]').val();
            Sage.consultantPosition = $('#consultantsSearch select[name=position]').val();
            Sage.consultantWorkarea = $('#consultantsSearch select[name=workarea]').val();
            Sage.consultantRegion   = $('#consultantsSearch select[name=region]').val();
            Sage.consultantNotIn    = [];

            var content = $('#consultantsContent');
            if(Sage.consultantName.length > 40) {
              $('#consultantsSearch input[name=name]').addClass('error');
              $('#consultantsSearch input[name=name] + p').text('Search text is too long.');
              return false;
            }
            $('#consultantsSearch input[name=name]').removeClass('error');

            ajaxElements.prop('disabled',false);
            Sage.actions.loadConsultants(security, formElements, content, 9, false);
          });
        }

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        $('.news__carousel').slick({
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 544,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                arrows: false
              }
            }
          ]
        });

        $('.items-line__list').slick({
          slidesToShow: 3,
          slidesToScroll: 3,
          arrows: false,
          dots: true,
          responsive: [
            {
              breakpoint: 9999,
              settings: "unslick"
            },
            {
              breakpoint: 544,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });

        setTimeout(function(){
          Sage.actions.randomClients();
        }, 500);

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    'single_consultant': {
      init: function () {
        iFrameResize({log:true}, '#cv_frame');
      }
    },
    'page_template_template_consultants': {
      init: function () {
        if($('#consultantsSearch[data-useonload]').length) {
          $('#consultantsSearch').submit();
        }
      }
    },
    'actions': {
      scrollTo: function (e,el) {
        var hash = e.target.hash;
        var offset = $('header.banner').outerHeight();

        if(hash !== '' && typeof hash === 'string') {
          $('html, body').animate({
            scrollTop: $( hash ).offset().top - offset
          }, 500);
        }
      },
      openSearch: function (e,el) {
        var search = $('.search-primary');
        var input = $('.search-primary .search-field');
        var body = $('html, body');
        var searchClose = $('.search-close');

        search.toggleClass('search-primary--active');
        input.focus();
        body.toggleClass('no-scroll');

        searchClose.on('click.searchClose', function(event) {
          event.preventDefault();
          search.removeClass('search-primary--active');
          body.removeClass('no-scroll');
          body.off('click.searchClose');
        });
        body.on('keyup.search',function(event) {
          if ( event.keyCode === 27 ) {
            event.preventDefault();
            search.removeClass('search-primary--active');
            body.removeClass('no-scroll');
            body.off('keyup.search');
          }
        });
      },
      toggleNav: function (e,el) {
        var nav = $('.nav-primary');
        var backdrop = $('.nav-primary__backdrop');
        var trigger = $('.navigation__trigger');
        var body = $('html, body');

        nav.toggleClass('nav-primary--active');
        trigger.toggleClass('navigation__trigger--active');
        body.toggleClass('no-scroll');

        body.on('keyup.nav',function(event) {
          if ( event.keyCode === 27 ) {
            event.preventDefault();
            nav.removeClass('nav-primary--active');
            trigger.removeClass('navigation__trigger--active');
            body.removeClass('no-scroll');
            body.off('keyup.nav');
          }
        });
        backdrop.on('click.navbackdrop',function(event) {
          event.preventDefault();
          nav.removeClass('nav-primary--active');
          trigger.removeClass('navigation__trigger--active');
          body.removeClass('no-scroll');
          backdrop.off('click.navbackdrop');
        });
      },
      popupVideo: function (e,el) {
        function validateYouTubeUrl(url)
        {
          if (url !== undefined || url !== '') {
            var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
            var match = url.match(regExp);
            if (match && match[2].length === 11) {
              return true;
            }
            else {
              return false;
            }
          }
        }
        function parseYoutubeURL(url){
          var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
          var match = url.match(regExp);
          return (match&&match[7].length===11)? match[7] : false;
        }
        function videoEmbedCode(url) {
          if(validateYouTubeUrl(url)) {
            var ytID = parseYoutubeURL(url);
            return '<iframe width="420" height="315" src="https://www.youtube.com/embed/' + ytID + '?rel=0&autoplay=1" frameborder="0" allowfullscreen></iframe>';
          }
        }

        e.preventDefault();
        var link = e.currentTarget.href;
        var body = $('body');
        var popup = $('<div class="video__popup"><a href="#" class="video__popup__close"><span class="fa fa-times"></span></a></div>');
        var popupContent = $('<div class="video__popup__content"></div>');

        popupContent.html(videoEmbedCode(link));

        popup.hide()
             .append(popupContent)
             .fadeIn(200);

        body.append(popup);

        $('.video__popup, .video__popup__close').on('click.popup touchend.popup', function (e) {
          e.preventDefault();
          $('.video__popup').fadeOut(200, function(e) {
            $('.video__popup').remove();
          });
        });
      },
      loadPosts: function(e, el) {
        e.preventDefault();
        var loadMoreBtns = $('[data-more="true"]');
        var btn = el;
        var btnOldLabel = btn.text();
        var data_target = btn.attr('data-target');
        var load_more = btn.attr('data-more');
        var post_type = btn.attr('data-post-type');
        var not_in = btn.attr('data-not-in');
        var count = btn.attr('data-count');
        var category = btn.attr('data-category');
        var security = btn.attr('data-security');

        var container = $('#' + data_target);
        var btnContainer = el.parent();

        if (post_type) {
          Sage.postsType = post_type;
        }
        if (category && category !== 'all') {
          Sage.category = category;
        } else if (category === 'all') {
          Sage.category = '';
        }
        if (count) {
          Sage.postsCount = count;
        }
        if (not_in && Sage.postsNotIn.length === 0) {
          var str = not_in;
          var arr = str.split(",");
          Sage.postsNotIn.push(arr);
          $.uniqArray = function(a) {
            return $.grep(Sage.postsNotIn, function(item, pos) {
              return $.inArray(item, Sage.postsNotIn) === pos;
            });
          };
        }

        $.ajax({
            url: ajax_object.ajax_url+'?t='+jQuery.now(),
            type: 'POST',
            data: {
              action: 'load-posts',
              post_type: Sage.postsType,
              not_in: (not_in ? Sage.postsNotIn.join() : []),
              category: Sage.category,
              count: Sage.postsCount,
              security: security
            },
            beforeSend: function () {
              container.addClass('is-loading');
              if(load_more === 'true') {
                btn.addClass('btn--disabled').text('...');
              }
            },
            success: function (resp) {
              var obj = JSON.parse(resp);
              btn.removeClass('btn--disabled').text(btnOldLabel);
              loadMoreBtns.removeClass('btn--disabled');
              container.removeClass('is-loading');

              if (obj.content !== '') {
                var str = obj.not_in;
                var arr = str.split(",");
                if (load_more === 'true') {
                  Sage.postsNotIn.push(arr);
                } else {
                  Sage.postsNotIn = arr;
                }
                if ($(container).hasClass('no-posts') || load_more !== 'true') {
                  $(container).removeClass('no-posts').html('');
                }
                $(obj.content).hide().appendTo(container).fadeIn(500);
                if(load_more === 'true' && obj.count < Sage.postsCount) {
                  btn.addClass('btn--disabled');
                }
              } else {
                if(load_more === 'true') {
                  btn.addClass('btn--disabled');
                } else {
                  $(container).addClass('no-posts').hide().html('Inga inlägg hittade.').fadeIn(500);
                }
              }
            }
        });
      },
      loadMoreConsultants: function(e, el) {
        e.preventDefault();
        var btn = el;
        var data_target = btn.attr('data-target');
        var count = btn.attr('data-count');
        var security = btn.attr('data-security');
        var content = $('#' + data_target);
        var not_in = btn.attr('data-not-in');

        if (not_in && Sage.consultantNotIn.length === 0) {
          var str = not_in;
          var arr = str.split(",");
          Sage.consultantNotIn.push(arr);
          Sage.consultantName     = $('#consultantsSearch input[name=name]').val();
          Sage.consultantPosition = $('#consultantsSearch select[name=position]').val();
          Sage.consultantWorkarea = $('#consultantsSearch select[name=workarea]').val();
          Sage.consultantRegion   = $('#consultantsSearch select[name=region]').val();
            
          $.uniqArray = function(a) {
            return $.grep(Sage.consultantNotIn, function(item, pos) {
              return $.inArray(item, Sage.consultantNotIn) === pos;
            });
          };
        }

        Sage.actions.loadConsultants(security, el, content, count, true);
      },
      loadConsultants: function(security, formElements, content, count, load_more) {
        if (content.hasClass('is-loading')) {
            return false;
        }
        $.ajax({
          url: ajax_object.ajax_url+'?t='+jQuery.now(),
          type: 'POST',
          data: {
            action: 'search-consultant',
            security: security,
            count: count,
            name: Sage.consultantName,
            position: Sage.consultantPosition,
            workarea: Sage.consultantWorkarea,
            region: Sage.consultantRegion,
            not_in: Sage.consultantNotIn.join()
          },
          beforeSend: function () {
            formElements.prop('disabled','disabled');
            if (!load_more) {
              content.addClass('is-loading');
              content.html('');
            }
            history.pushState(null, null, Sage.actions.updateQueryStringParameter(window.location.href,'q',escape(Sage.consultantName)));
            history.pushState(null, null, Sage.actions.updateQueryStringParameter(window.location.href,'position',escape(Sage.consultantPosition)));
            history.pushState(null, null, Sage.actions.updateQueryStringParameter(window.location.href,'workarea',escape(Sage.consultantWorkarea)));
            history.pushState(null, null, Sage.actions.updateQueryStringParameter(window.location.href,'region',escape(Sage.consultantRegion)));
          },
          success: function (resp) {
            var results = JSON.parse(resp);
            content.removeClass('is-loading');
            formElements.prop('disabled',false);
            Sage.isLoading = false;
            if (results.content !== '') {
              var str = results.not_in;
              var arr = str.split(",");
              Sage.emptyResults = false;
              if (load_more) {
                Sage.consultantNotIn.push(arr);
                content.append(results.content);
              } else {
                Sage.consultantNotIn = arr;
                content.html(results.content);
              }
            } else {
              Sage.emptyResults = true;
              if (!load_more) {
                content.html('<p class="no-results">'+communicate_noresults+'</p>');
              } else {
                formElements.prop('disabled',true);
              }
            }
          }
        });
      },
      randomClients: function() {
        var clientsContainer = $('#randomClients');
        if(clientsContainer.length > 0) {
          var security = clientsContainer.attr('data-security');
          setInterval(function(){
            $.ajax({
              url: ajax_object.ajax_url+'?t='+jQuery.now(),
              type: 'POST',
              data: {
                action: 'load-clients',
                security: security
              },
              success: function (resp) {
                var obj = JSON.parse(resp);
                clientsContainer.addClass('is-loading');
                setTimeout(function(){
                  clientsContainer.removeClass('is-loading');
                  clientsContainer.html(obj.content);
                }, 500);
              }
            });
          }, 10000);
        }
      },
      updateQueryStringParameter: function(uri, key, value) {
        var i = uri.indexOf('#');
        var hash = (i === -1 ? '' : uri.substr(i));
            uri = (i === -1 ? uri : uri.substr(0, i));
        var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        var separator = uri.indexOf('?') !== -1 ? "&" : "?";
        if (uri.match(re)) {
            uri = uri.replace(re, value !== '' ? '$1' + key + "=" + escape(value) + '$2' : '');
        } else {
            uri = uri + (value !== '' ? separator + key + "=" + escape(value) : '');
        }
        return uri + hash;
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
